import type { FC } from 'react';
import cn from 'classnames';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconReject } from './img/iconReject.svg';
import { ReactComponent as IconTime } from './img/iconTime.svg';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { ReactComponent as IconCheck } from './img/iconCheck.svg';
import { ReactComponent as IconCheckDouble } from './img/iconCheckDouble.svg';
import { ReactComponent as IconCommentGray } from './img/iconCommentGray.svg';
import styles from './ContractItem.module.scss';
import { FormatAmount } from 'ui/FormatAmount';
import { Avatar } from 'components/Avatar';
import { ContractActions } from './ContractActions';
import { ContractStatus, ContractType } from 'redux/Api/contractsApi/type';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { statusColor } from 'components/ContractsListMobile';
import moment from 'moment';
import { TooltipDate } from 'ui/CustomerOrderItem';
import { AppTooltip } from 'ui/AppTooltip';

interface ContractItemTypes {
  contract: ContractType;
  hidePerformer?: boolean;
}

export const statusIcons: Record<ContractStatus, JSX.Element> = {
  signed_by_customer: <IconTime />,
  signed_by_worker: <IconDone />,
  rejected: <IconCancel />,
  revoked: <IconReject />,
  terminated: <IconReject />,
  expired: <IconReject />,
};

export const statusText: Record<ContractStatus, string> = {
  signed_by_customer: 'Ждем подпись',
  signed_by_worker: 'Договор подписан',
  rejected: 'Отклонен',
  revoked: 'Отозван',
  terminated: 'Расторгнут',
  expired: 'Истек срок',
};

export const ContractItem: FC<ContractItemTypes> = ({
  contract,
  hidePerformer = false,
}) => {
  return (
    <div className={cn(hidePerformer ? styles.rootNoPerformer : styles.root)}>
      <TextWithTooltip content={String(contract.number)} className={styles.truncate} />
      <div>
        {contract.date_start ? (
          <div style={{ padding: '0 12px' }}>
            <TooltipDate date={moment(contract.date_start).format('DD.MM.YYYY HH:mm')} />
          </div>
        ) : (
          ''
        )}
      </div>
      <div>
        {' '}
        {contract.date_end ? (
          <div style={{ padding: '0 12px' }}>
            <TooltipDate date={moment(contract.date_end).format('DD.MM.YYYY HH:mm')} />
          </div>
        ) : (
          'Бессрочно'
        )}
      </div>
      <div>
        {contract.customer_signed_at ? (
          <div style={{ padding: '0 12px' }}>
            <TooltipDate
              date={moment(contract.customer_signed_at).format('DD.MM.YYYY HH:mm')}
            />
          </div>
        ) : (
          ''
        )}
      </div>
      <div>
        {contract.worker_signed_at ? (
          <div style={{ padding: '0 12px' }}>
            <TooltipDate
              date={moment(contract.worker_signed_at).format('DD.MM.YYYY HH:mm')}
            />
          </div>
        ) : (
          ''
        )}
      </div>

      {!hidePerformer && (
        <div className={styles.worker}>
          <Avatar
            name={contract.worker.name}
            surname={contract.worker.surname}
            avatar={contract.worker.avatar}
            statusActive={''}
            id={contract.worker.id}
            isDeleted={contract.worker.is_deleted}
          />
          <div className={styles.workerInfo}>
            <TextWithTooltip
              content={`${contract.worker.surname} ${contract.worker.name} ${
                contract.worker.patronymic || ''
              }`}
              className={styles.workerInfo_name}
            />
            {contract.worker.is_deleted && (
              <TextWithTooltip
                content='Профиль удален'
                className={styles.workerInfo_deleted}
              />
            )}
          </div>
        </div>
      )}
      <div>
        <TextWithTooltip
          content={contract.oferta?.title || 'Единый договор'}
          className={styles.truncate}
        />
        <div className={styles.statusWithDate}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '0 0 0 12px',
              flexShrink: 0,
            }}>
            {statusIcons[contract.status as ContractStatus]}
          </div>
          <div className={styles.statusWithDate_text}>
            <div
              className={styles.statusText}
              style={{ color: statusColor[contract.status as ContractStatus] }}>
              <div className={styles.statusTextContent}>
                {statusText[contract.status as ContractStatus]}
                {(contract.status === 'rejected' || contract.status === 'terminated') &&
                contract.status_changed_at ? (
                  <TooltipDate
                    date={moment(contract.status_changed_at).format('DD.MM.YYYY HH:mm')}
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <TextWithTooltip
        content={contract?.worker?.nationality || ''}
        className={styles.truncate}
      />
      <div className={styles.status}>
        {contract.is_mvd_notified && contract.is_mvd_notified_on_termination ? (
          <IconCheckDouble />
        ) : contract.is_mvd_notified || contract.is_mvd_notified_on_termination ? (
          <IconCheck />
        ) : null}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {contract.comment ? (
          <AppTooltip label={contract.comment}>
            <IconCommentGray style={{ cursor: 'pointer' }} />
          </AppTooltip>
        ) : (
          <div></div>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <ContractActions
          contract={contract}
          status={contract.status}
          isResident={contract?.worker?.nationality === 'Россия'}
        />
      </div>
    </div>
  );
};
